import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon } from 'components'
import styles from './Arrow.module.scss'

const isIOS =
  (window.navigator.userAgent.includes('iPhone') ||
    window.navigator.userAgent.includes('Safari')) &&
  window.navigator.vendor.includes('Apple')

const Arrow = ({ onClick, arrowDirection }) => (
  <Button type="text" onClick={onClick} className={styles.arrowButton}>
    <Icon
      type="arrow"
      size={16}
      color="grayColor"
      rotate={0}
      className={
        styles[isIOS ? `${arrowDirection}IconIOS` : `${arrowDirection}Icon`]
      }
    />
  </Button>
)

Arrow.propTypes = {
  onClick: PropTypes.func.isRequired,
  arrowDirection: PropTypes.string.isRequired,
}

export default Arrow
